export const GET_BUSINESSES = gql`
    query GetBusinesses {
        businesses {
            id
            hierarchyLevel
            legalName
            partnerId
            partnerOfPartnerId
            merchantId
        }
    }
`;
